// src/menuitems/menuItemsDirector.js

import React from "react";
import {
    FiList,
    FiCheckSquare,
    FiUsers,
    FiMessageSquare,
    FiFolder,
    FiCreditCard,
    FiFileText,
    FiBriefcase,
    FiBarChart2,
    FiUser,
} from "react-icons/fi";
import { FaFile, FaFileAlt, FaGavel, FaUserCheck, FaWarehouse, FaUserCircle } from "react-icons/fa";

const menuItemsDirector = [
    {
        label: "PD Dashboard",
        icon: <FiBriefcase />,
        path: "/program-director"


    },
    { label: "Project Management", icon: <FiBriefcase />, path: "/projects" },
    { label: "Donor Management", icon: <FiUsers />, path: "/donor-management" },
    { label: "Leave Management", icon: <FaUserCheck />, path: "/leave-management" },
    { label: "Disciplinary", icon: <FaGavel />, path: "/disciplinary-management" },
    { label: "Timesheet", icon: <FaFileAlt />, path: "/director-timesheet" },
    { label: "Asset Inventory", icon: <FaWarehouse />, path: "/director-assets" },


    { label: "Procurement", icon: <FiFolder />, path: "/pd/procurement" },


    {
        label: "Documentation",
        icon: <FaFile />,
        path: "/document-management",
    },
    { label: "My Profile", icon: <FaUserCircle />, path: "/pd-profile" },

];


export default menuItemsDirector;
